<div [ngStyle]="{ overflow: 'hidden', display: documentExist ? 'block' : 'none' }">
  <div fxLayout="column" fxLayoutGap="10px grid" class="documentCardList" fxFill>
    <abcCard
      *ngFor="let document of documentsList"
      fxFlex="100"
      id="{{ document.Id }}"
      [class]="'cardDocument'"
      displayText="{{ document.Designation }}"
      secondaryDisplayText="{{ document.Kind }} {{ ConvertHelper.toDate(document.Date) }} {{
        getDocumentFileName(document)
      }}"
      [leftIsImg]="false"
      [leftIconPosition]="1"
      [leftIconSize]="2"
      leftIconPath="{{ tryGetDocumentType(document) }}"
      [buttons]="document.Buttons"
    >
    </abcCard>
  </div>
</div>

<abcLoader [show]="showLoader"></abcLoader>

<div
  [ngStyle]="{
    display: !documentExist && !showLoader ? 'block' : 'none'
  }"
>
  {{ res('DocumentsEditorCard-NoDocuments') }}
</div>

<div #abcWindowContainer id="abcWindowContainer"></div>

<div *ngIf="isIconsVisible && isAllowed && !isReadOnly" class="addDocButton">
  <button mat-fab class="fab-toggler" (click)="detailDocument()">
    <i class="material-icons">add</i>
  </button>
</div>
